<template>
  <div>
    <component :is="template"></component>
  </div>
</template>

<script>
import Bpmn from 'biyi-hx-activiti/src/views/flow/Bpmn'

export default {
  name: 'BpmnEdit',
  components: {
    Bpmn
  },
  data () {
    return {
      template: ''
    }
  },
  created () {
    this.template = 'Bpmn'
  }
}
</script>

<style scoped>

</style>
